import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { CategoryGridItemForm } from "./CategoryGridItemForm";
import { Button } from "components/ui/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { categoryGridSchema } from "validations/widgetFields.validation";
import { useForm } from "react-hook-form";
import { CATEGORY_GRID_SCHEMA } from "constants/widget-constant";
import { TextField } from "components/styledFormElements/TextField";

type GridItem = {
    id: string;
    title: string;
    icon: string;
    landingUrl: string;
    order: number;
};

export const CategoryGridEditor = ({
    widget,
    setWidgetDraftData
}: {
    widget: any;
    setWidgetDraftData: (data: any) => void
}) => {

    const [editingItem, setEditingItem] = useState<GridItem | null>(null);
    const [showAddItem, setShowAddItem] = useState(false);
    const [gridItems, setGridItems] = useState<any>([]);

    const {
        register,
        formState: { errors },
        getValues,
    } = useForm({
        resolver: yupResolver(categoryGridSchema),
        mode: "onTouched",
    });

    useEffect(() => {
        const CategoryWidgetData = {
            ...widget,
            items: {
                ...getValues(),
                items: gridItems,
            }
        };
        //  setWidgetDraftData({ ...CategoryWidgetData, widget_name: widget?.widget_name, widget_id: widget?.widget_id, u_widget_id: widget?.u_widget_id, widget_code: widget?.widget_code });
        setWidgetDraftData({...CategoryWidgetData});
    }, [gridItems]);

    return (
        <div className="grid grid-cols-2 gap-6">
            {/* LEFT PANEL */}
            <div className="border rounded-lg p-4 flex flex-col">
                <div className="space-y-3">
                    {CATEGORY_GRID_SCHEMA.fields.map((field: any) => (
                        <TextField
                            key={field.name}
                            register={register(field.name)}
                            errors={errors}
                            label={field.label}
                            type={field.type}
                        />
                    ))}
                </div>

                <div className="border-t my-4" />

                <div className="flex-1">
                    <div className="flex justify-between mb-2">
                        <h4 className="font-semibold">Grid items</h4>
                        <Button
                            type="button"
                            onClick={() => setShowAddItem(true)}
                            color="blue-accent"
                        >
                            + Add item
                        </Button>
                    </div>

                    <div className="space-y-2">
                        {gridItems.map((item, index) => (
                            <div
                                key={index}
                                className="border rounded p-2"
                            >
                                {item.title}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* RIGHT PANEL */}
            {showAddItem && (
                <CategoryGridItemForm
                    item={editingItem}
                    onSave={(item) => {
                        setGridItems([...gridItems, item]);
                    }}
                    setShowAddItem={setShowAddItem}
                />
            )}
        </div>
    );
};

